"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGlobalDefaults = exports.GlobalDefaultKeys = void 0;
var tslib_1 = require("tslib");
var conduction_method_1 = require("../conduction-method");
exports.GlobalDefaultKeys = {
    UseNewApi: '__WIXEXP_USE_NEW_API',
    ConductionMethod: '__WIXEXP_CONDUCTION_METHOD_',
    OwnerAccountId: '__WIXEXP_OWNER_ACCOUNT_ID_',
    LoggedInUserId: '__WIXEXP_LOGGED_IN_USER_ID_',
};
function getValueOrEmptyObject(objectKey, globalValueKey, type) {
    var _a, _b;
    if (typeof self !== 'undefined') {
        if (typeof type === 'function') {
            if (typeof type(self[globalValueKey]) !== 'undefined') {
                return _a = {}, _a[objectKey] = type(self[globalValueKey]), _a;
            }
        }
        else if (typeof self[globalValueKey] === type) {
            return _b = {}, _b[objectKey] = self[globalValueKey], _b;
        }
    }
    return {};
}
var checkConductionMethod = function (conductionMethod) {
    return Object.keys(conduction_method_1.ConductionMethod).filter(function (cm) { return conduction_method_1.ConductionMethod[cm] === conductionMethod; }).length > 0
        ? conductionMethod
        : undefined;
};
function getGlobalDefaults() {
    return tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, getValueOrEmptyObject('useNewApi', exports.GlobalDefaultKeys.UseNewApi, 'boolean')), getValueOrEmptyObject('conductionMethod', exports.GlobalDefaultKeys.ConductionMethod, checkConductionMethod)), getValueOrEmptyObject('siteOwnerId', exports.GlobalDefaultKeys.OwnerAccountId, 'string')), getValueOrEmptyObject('loggedInUserId', exports.GlobalDefaultKeys.LoggedInUserId, 'string'));
}
exports.getGlobalDefaults = getGlobalDefaults;
//# sourceMappingURL=global-defaults.js.map